import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isAssignCalendarHolidaysToResourceRequestFailure({ uuid }) {
      const state = getState().find(({ resource }) => uuid === resource.uuid);

      return state ? state.request.isFailure : false;
    },
    isAssignCalendarHolidaysToResourceRequestPending({ uuid }) {
      const state = getState().find(({ resource }) => uuid === resource.uuid);

      return state ? state.request.isPending : false;
    },
    isAssignCalendarHolidaysToResourceRequestSuccess({ uuid }) {
      const state = getState().find(({ resource }) => uuid === resource.uuid);

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
